<template>
  <!-- 周年庆留言板 -->
  <GuestBook v-if="isGlobal && customSetting?.carnivalSwitch"/>
  <!-- banner图 -->
  <swiper 
    v-if="bannerList.length"
    class="swiper-container"
    :space-between="30"
    :modules="modules"
    :loop="true"
    :pagination="{
      clickable: true
    }"
    :autoplay="{
      delay: 5000,
    }"
    @slideChange="changeSwiper"
  >
    <swiper-slide v-for="(banner, index) in bannerList" :key="index">
          <ObImg :lazy="!!index" :fetchpriority="!index ? 'high' : 'auto'" :src="banner.imageWap" :duration="0" @click="onJump(banner.webLink, index)"/>
    </swiper-slide>
  </swiper>
  <template v-if="recommendeList.length" >
    <p class="recommended-title">{{ $t('recommended') }}</p>
    <div class="recommend-wrap" @touchmove.stop>
      <RecommendedCard 
        v-for="(recommended, index) in recommendeList"
        :key="index"
        :recommendedData="recommended"
        :index="index + 1"
      />
    </div>
  </template>
  <TopicList />
  <div class="selection-block"
    :style="{
      top: `calc(${(navigationHeight * 1) + (noticeHeight * 1)}px + 42px)`
    }"
  >
    <ObSelection
      v-if="options?.length && showSelection"
      v-model="sortType"
      :options="options"
      :fitWidth="true"
      :showOverlay="showLayer"
      @select="switchType"
    />
  </div>
  <RankList v-if="!list?.length"/>
  <ObList
    ref="obListRef"
    :load="getExploreList"
  >
    <template v-if="showList"  v-for="(item, index) in list" :key="item.id">
      <component
        :is="item.components" 
        :cardInfo="item"
        :showTag="!!item?.circleInfo?.id"
        :index="index"
        :showStick="Boolean(item.stick)"
      />
      <RankList v-if="showRankList(index)"/>
    </template>
    
  </ObList>
</template>

<script setup>
import RankList from './rankList'
import TopicList from './topicList'
import GuestBook from '@/views/activities/guestbook'

import { $throttle } from '@/utils/lodashFuncs'
import { storeToRefs } from 'pinia'
import { useSystemStore } from '@/stores/system'
import { useNavigationStore } from '@/stores/navigation'

// swiper： Navigation（导航标） Pagination（分页器） Autoplay（自动播放）
import { Pagination, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'

const modules = [Pagination, Autoplay]

const route = useRoute()
const systemStore = useSystemStore()  // 用户仓库
const navigationStore = useNavigationStore()  // 用户仓库
const { proxy } = getCurrentInstance()
const { navigationHeight, noticeHeight } = storeToRefs(navigationStore)   // 用户id
const { isApp, customSetting, exploreSortMenuSwitch } = storeToRefs(systemStore)   // 用户id

const obListRef = ref(null)

const sortType = ref(1)
const showList = ref(false)
const showLayer = ref(false)
const showSelection = ref(false)
const isGlobal = ref(import.meta.env.VITE_COUNTRY === 'GLOBAL')

const list = ref([])
const bannerList = ref([]) // banner图列表

const gaBannerView = ref([])
const recommendeList = ref([]) // 推荐列表

const options = computed(() => {
  let allMenu = [{
    label: proxy.$t('homePage.recommended'),
    name: 'recommended',
    value: 1
  },{
    label: proxy.$t('homePage.daily'),
    name: 'day',
    value: 3
  },{
    label: proxy.$t('homePage.weekly'),
    name: 'week',
    value: 2
  },{
    label: proxy.$t('homePage.latest'),
    name: 'newest',
    value: 4
  }]
  const showMap = Object.keys(exploreSortMenuSwitch.value).filter(i => !!exploreSortMenuSwitch.value[i] )
  allMenu = allMenu.filter(i => showMap.includes(i.name))
  sortType.value = allMenu[0] ? allMenu[0].value : []
  return allMenu
})

const showRankList = computed(() => (index) => {
  return (list.value.length >= 4 && index === 3) || (list.value.length < 4 && index === (list.value.length - 1))
})

function switchType () {
  list.value = []
  obListRef.value.onRefresh()
}

function changeSwiper (val) {
  nextTick(() => {
  // 如果不在可视区域、不触发埋点
    if (!document.querySelector('.swiper-container') || document.querySelector('.swiper-container').getBoundingClientRect().y < -365) return
    if (val.activeIndex > bannerList.value.length) {
      return
    }
    if (!gaBannerView.value.includes(val.activeIndex)) {
      gaBannerView.value.push(val.activeIndex)
      proxy.$ga('homepage_banner_impression', {
        "screen_name": route.name,
        "destination": bannerList.value[val.activeIndex]?.webLink,
        "position": String(val.activeIndex)
      })
    }
  })
}

function onJump (webLink, index) {
  proxy.$ga('homepage_banner_entry', {
    "screen_name": route.name,
    "destination": webLink,
    "position": index
  })
  if (isApp.value) {
    proxy.$openNewWebview(webLink)
  } else {
    if (webLink.includes(location.origin)) {
      location.href = webLink
    } else {
      window.open(webLink)
    }
  }
}

// 获取banner列表
async function getBannerList () {
  let response = null
  try {
    response = JSON.parse(document.getElementById('home-banner-list').innerText) ?? {}
  } catch {}
  if (!response || response?.code !==200) {
    response = await proxy.$http.getBannerList() || {}
  }
  const { code, data } = response
  if (code !== 200 || !data) return
  bannerList.value = [...data]
}

// 获取推荐卡片,默认取前6
async function getRecommendedList () {
  let response = null
  try {
    response = JSON.parse(document.getElementById('recommend-banner-list').innerText) ?? {}
  } catch {}
  if (!response || response?.code !==200) {
    response = await proxy.$http.getRecommendedCard() || {}
  }
  const { code, data } = response
  if (code !== 200 || !data?.length) return
  recommendeList.value = [...data]
}

async function getExploreList (params) {
  const { pageData = {
    page: 1,
    limit: 20
  } } = params || {}
  const { code, data} = await proxy.$http.getExploreList({
    ...pageData,
    type: sortType.value
  })
  let finished = false
  if (code === 200 && data) {
    const { rows, total } = data || {}
    for(const i of rows) {
      switch (i.type) {
        case 1:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/articleCard.vue')))
          break
        case 2:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/momentCard.vue')))
          break
        case 4:
          i.components = markRaw(defineAsyncComponent(() => import('@/components/card/pollCard.vue')))
          break
        default:
      }
    }
    list.value = [...list.value, ...rows]
    finished = list.value.length >= total || !rows?.length
  }
  return {
    code,
    finished
  }
}

watch(obListRef, (val) => {
  if (val?.$el) {
    window.addEventListener('scroll', $throttle((e) => {
      const { top } = obListRef.value?.$el.getBoundingClientRect() || {}
      if (top < (navigationHeight.value * 2)) {
        showSelection.value = true
      } else {
        showSelection.value = false
      }
    }, 100))
  }
}, {
  immediate: true,
  deep: true
})


onBeforeMount(async () => {
  await getBannerList()
  await getRecommendedList()
  showList.value = true
})

</script>

<style lang="postcss" scoped>
.selection-block {
  width: 100%;
  position: fixed;
  z-index: 100;
  :deep(.ob-selection) {
    width: 100vw;
  }
}

  
.recommended-title {
  font-size: 16px;
  margin: 8px 20px 8px;
  font-family: 'orbit-M';
}
.recommend-wrap {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100vw;
  padding: 0 20px;
  overflow: auto;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }
}
:deep(.el-check-tag) {
  margin: 16px 8px 8px;
}

.swiper-container {
  width: 100vw;
  height: 100%;
  margin: 0 0 8px;
  --swiper-theme-color: #1989fa; /* 设置Swiper风格 */
  & :deep(.el-image)  {
    width: 100vw;
    height: 100%;
    aspect-ratio: 16/9;
  }
  
  :deep(.swiper-pagination-bullet) {
    width: 6px;
    height: 6px;
    background:rgba(255, 255, 255, 0.40);
    margin:0 3px;
  }
  :deep(.swiper-pagination-bullet-active) {
    background:#ffffff;
  }
}

</style>